"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.MasterPolicyInsuranceLicense = void 0;
class MasterPolicyInsuranceLicense {
    constructor(licensee, licenseNumber, type, expirationDate) {
        this.licensee = licensee;
        this.licenseNumber = licenseNumber;
        this.type = type;
        this.expirationDate = expirationDate;
    }
    static fromObj(obj) {
        if (obj.owner)
            return new MasterPolicyInsuranceLicense(obj.owner, obj.licenseNumber);
        return new MasterPolicyInsuranceLicense(obj.licensee, obj.licenseNumber, obj.type, obj.expirationDate);
    }
    isEqual(to) {
        return (this.licensee === to.licensee &&
            this.licenseNumber === to.licenseNumber &&
            (this === null || this === void 0 ? void 0 : this.type) === (to === null || to === void 0 ? void 0 : to.type) &&
            (this === null || this === void 0 ? void 0 : this.expirationDate) === (to === null || to === void 0 ? void 0 : to.expirationDate));
    }
}
exports.MasterPolicyInsuranceLicense = MasterPolicyInsuranceLicense;
//# sourceMappingURL=MasterPolicyInsuranceLicense.class.js.map